export default __webpack_public_path__ + "static/va-loans-2-981f52d8b27d4d0371f6e8c4a2cf9c93.png";